import React, { useCallback } from 'react';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import Grid from '../../../Grid';
import { DeviationLink } from '../../../Duperbrowse';
import { getTranslatedDeviationTitle } from '../../../DeviationViews/_helpers';
import DumboWithIcon from '../../../DeviationViews/DumboWithIcon/DumboWithIcon';
import { useTranslation } from 'react-i18next';
import { MeasuredCookieType } from '../../../Measured';
import s from './ExhibitionistGrid3x3.scss';
const ExhibitionistGrid3x3 = ({ moduleId })=>{
    const { t } = useTranslation();
    const { moduleData } = useModuleData(moduleId);
    const { deviations } = moduleData;
    const renderItem = useCallback(({ height, width, index, style })=>{
        const item = deviations[index];
        return /*#__PURE__*/ React.createElement("div", {
            style: style,
            key: index
        }, /*#__PURE__*/ React.createElement(DeviationLink, {
            deviation: item,
            key: item.deviationId,
            title: getTranslatedDeviationTitle(item, t)
        }, /*#__PURE__*/ React.createElement(DumboWithIcon, {
            deviation: item,
            width: width,
            height: height,
            greenLikeCrop: true,
            withSeoData: false
        })));
    }, [
        deviations,
        t
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Grid, {
        lazyloadFromContext: true,
        enableScrollOptim: false,
        containerWidth: 308,
        defaultSize: {
            desktop: {
                width: 308,
                height: 308
            },
            mobile: {
                width: 308,
                height: 308
            }
        },
        cookieType: MeasuredCookieType.DEVIATION_SIDEBAR,
        maxRows: 3,
        breakpoints: [
            {
                maxWidth: 600,
                elementsPerRow: 3,
                elementAspectRatio: 1
            }
        ],
        spacing: 16,
        elementCount: deviations.length,
        renderElement: renderItem
    }));
};
ExhibitionistGrid3x3.displayName = 'ExhibitionistGrid3x3';
export default ExhibitionistGrid3x3;
